import { NavLink as RouterLink } from "react-router-dom"
import styled, { css } from "styled-components"

import rightIcon from "../../assets/icons/icon-chevronright.svg"
import closeIcon from "../../assets/icons/icon-close.svg"
import { ImageButton } from "../../styles/button"

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;

  padding: 20px 0;

  background-color: #fff;
`

export const CloseButton = styled(ImageButton).attrs(() => ({
  src: closeIcon
}))`
  position: absolute;
  top: 15px;
  right: 15px;

  display: none;

  width: 30px;
  height: 30px;

  margin-bottom: 20px;
`

const linkStyling = css`
  color: #000;
  line-height: 1.3;
  font-weight: 700;
  font-size: 0.9em;
  font-family: ${props => props.theme.fonts.secondary};
  text-transform: capitalize;
  text-decoration: none;
  text-align: left;

  :hover {
    color: ${props => props.theme.colours.main};
  }

  ${props =>
    props.$isSelected &&
    css`
      color: ${() => props.theme.colours.main};
    `}

  @media (max-width: ${props => props.theme.sizes.navigation.mobile}px) {
    width: 100%;
    box-sizing: border-box;
    padding: 15px 40px;
    font-weight: 400;
    font-size: 1.1em;
    background-image: url(${rightIcon});
    background-repeat: no-repeat;
    background-position: 90% 20px;
    background-size: 15px;
  }
`

export const NavLink = styled(RouterLink)`
  ${linkStyling};
`

export const Menu = styled.div`
  position: absolute;
  top: 75px;

  display: flex;
  flex-direction: column;
  align-items: flex-end;

  ${props =>
    props.$isVisible
      ? css`
          opacity: 1;
          transition: opacity 0.2s ease-in-out;
        `
      : css`
          opacity: 0;
          transition: opacity 0.2s ease-in-out;
          pointer-events: none;
        `}

  ${NavLink} {
    display: none;
  }

  @media (max-width: ${props => props.theme.sizes.navigation.mobile}px) {
    top: 60px;
    right: 0;

    align-items: center;

    width: 100vw;
    height: calc(100vh - 60px);

    background-color: #fff;

    ${NavLink} {
      display: initial;
    }

    ${LinkContainer} {
      align-items: flex-start;

      padding-top: 20px;
      width: 100%;

      background-color: transparent;
    }

    ${CloseButton} {
      display: initial;
    }
  }
`

export const LanguageContainer = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  gap: 20px;
  padding: 0 40px 20px 0;
  margin-top: auto;
`

export const LanguageLink = styled(RouterLink)`
  text-decoration: none;
  color: #000;

  ${props =>
    props.$isActive &&
    css`
      font-weight: bold;
    `};
`

export const ContactWrapper = styled.div`
  padding: 0 40px;
  width: 100%;

  a {
    padding: 12px 31px;
  }
`
